import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { SearchTypesEnum } from 'widgets/SearchDropdown'
import { useSearchDropdownContext } from 'widgets/SearchDropdown/context/searchDropdownContext'
import { TagElement } from './TagElement/TagElement'
import { TeamElement } from './TeamElement/TeamElement'
import { UserElement } from './UserElement/UserElement'
import { ContactsElement } from './ContactsElement/ContactsElement'
import { DateElement } from './DateElement/DateElement'
import { NumbersElement } from './NumbersElement/NumbersElement'
import { OutboundSourcesElement } from './OutboundSourcesElement/OutboundSourcesElement'

type ISearchElementProps = {
  type: SearchTypesEnum
  parentsDropdownId?: string[]
}

export const SelectedElement: FC<ISearchElementProps> = observer(({ type, parentsDropdownId }) => {
  const {
    newType,
    deleteType,
    canShowChildDropdown,
    searchDropdownTagsStore,
    searchDropdownInboxesStore,
    searchDropdownNumbersStore,
    searchDropdownAssigneeStore,
    searchDropdownMembersStore,
    searchDropdownContactsStore,
    searchDropdownOutboundSourceStore,
    searchDropdownDateStore,
  } = useSearchDropdownContext()

  switch (type) {
    case SearchTypesEnum.tags:
      return (
        <TagElement
          store={searchDropdownTagsStore}
          activeType={newType}
          onRemove={deleteType}
          canShowChildDropdown={canShowChildDropdown}
          parentsDropdownId={parentsDropdownId}
        />
      )
    case SearchTypesEnum.teams:
      return (
        <TeamElement
          store={searchDropdownInboxesStore}
          activeType={newType}
          onRemove={deleteType}
          canShowChildDropdown={canShowChildDropdown}
          parentsDropdownId={parentsDropdownId}
        />
      )
    case SearchTypesEnum.assignee:
      return (
        <UserElement
          store={searchDropdownAssigneeStore}
          activeType={newType}
          onRemove={deleteType}
          canShowChildDropdown={canShowChildDropdown}
          parentsDropdownId={parentsDropdownId}
        />
      )
    case SearchTypesEnum.members:
      return (
        <UserElement
          store={searchDropdownMembersStore}
          activeType={newType}
          onRemove={deleteType}
          canShowChildDropdown={canShowChildDropdown}
          parentsDropdownId={parentsDropdownId}
        />
      )
    case SearchTypesEnum.contacts:
      return (
        <ContactsElement
          store={searchDropdownContactsStore}
          activeType={newType}
          onRemove={deleteType}
          canShowChildDropdown={canShowChildDropdown}
          parentsDropdownId={parentsDropdownId}
        />
      )
    case SearchTypesEnum.numbers:
      return (
        <NumbersElement
          store={searchDropdownNumbersStore}
          activeType={newType}
          onRemove={deleteType}
          canShowChildDropdown={canShowChildDropdown}
          parentsDropdownId={parentsDropdownId}
        />
      )
    case SearchTypesEnum.outbound_sources:
      return (
        <OutboundSourcesElement
          store={searchDropdownOutboundSourceStore}
          activeType={newType}
          onRemove={deleteType}
          canShowChildDropdown={canShowChildDropdown}
          parentsDropdownId={parentsDropdownId}
        />
      )
    case SearchTypesEnum.date:
      return (
        <DateElement
          store={searchDropdownDateStore}
          activeType={newType}
          onRemove={deleteType}
          canShowChildDropdown={canShowChildDropdown}
          parentsDropdownId={parentsDropdownId}
        />
      )
    default:
      return null
  }
})
